import React from "react";
import { EuiFacetGroup, EuiTitle, EuiFacetButton } from "@elastic/eui";
import { useSearchkit } from "@searchkit/client";

export const OverridableListFacet = ({ facet, loading }) => {
  const api = useSearchkit();

  const entries = facet.entries?.map((entry) => (
    <EuiFacetButton
      style={{ paddingInline: "0px", fontWeight: 400 }}
      key={entry.value}
      quantity={entry.count}
      isSelected={api.isFilterSelected({
        identifier: facet.identifier,
        value: entry.value,
      })}
      onClick={() => {
        api.toggleFilter({
          identifier: facet.identifier,
          value: entry.value,
        });
        api.setPage({ from: 0 });
        api.search();
      }}
      isLoading={loading}
    >
      {entry.overrideLabel || entry.label}
    </EuiFacetButton>
  ));

  return (
    <>
      <EuiTitle size="xxs">
        <h3>{facet.label}</h3>
      </EuiTitle>
      <EuiFacetGroup style={{ padding: "0px", gap: "0px" }}>
        {entries}
      </EuiFacetGroup>
    </>
  );
};

OverridableListFacet.DISPLAY = "OverridableListFacet";
